import { graphql } from '@/graphql';

export const previewBulkDeletionQuery = graphql(`
  query PreviewBulkDeletion($projectId: ID!, $kind: BulkDeletionKind!, $ids: [ID!]!) {
    previewBulkDeletion(projectId: $projectId, kind: $kind, ids: $ids) {
      fingerprint
      requestedCount
      layerCount
      uploadBatchCount
      analysisBatchCount
      attachmentCount
      byproductCount
      sampleNames
    }
  }
`);

export const bulkDeleteLayersMutation = graphql(`
  mutation BulkDeleteLayers($projectId: ID!, $ids: [ID!]!, $fingerprint: String!) {
    bulkDeleteLayers(projectId: $projectId, ids: $ids, fingerprint: $fingerprint) {
      id
      status
    }
  }
`);

export const bulkDeleteBatchesMutation = graphql(`
  mutation BulkDeleteBatches($projectId: ID!, $ids: [ID!]!, $fingerprint: String!) {
    bulkDeleteBatches(projectId: $projectId, ids: $ids, fingerprint: $fingerprint) {
      id
      status
    }
  }
`);

export const deletionOperationsQuery = graphql(`
  query DeletionOperations($projectId: ID!) {
    deletionOperations(projectId: $projectId) {
      id
      kind
      status
      completedTargets
      totalTargets
      lastError
      createdAt
      completedAt
    }
  }
`);
